<template>
  <svg
    :class="computedClass"
    :width="size"
    :height="size"
    viewBox="0 0 18 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.65942 2.29924H10.2826M12.0942 11.2955H13.5435M4.12319 11.2955H5.57246M2.67391 9.85606H14.9928M14.9928 6.97727H16.442C16.8406 6.97727 17.1667 6.65341 17.1667 6.25758V4.09848C17.1667 3.70265 16.8406 3.37879 16.442 3.37879H14.9928M2.67391 6.97727H1.22464C0.826087 6.97727 0.5 6.65341 0.5 6.25758V4.09848C0.5 3.70265 0.826087 3.37879 1.22464 3.37879H2.67391M12.0942 14.1742V15.6136C12.0942 16.0095 12.4203 16.3333 12.8188 16.3333C13.2174 16.3333 13.5435 16.0095 13.5435 15.6136V14.1742M13.5435 14.1742C14.9928 14.1742 14.9928 12.7348 14.9928 12.7348V1.93939C14.9928 0.5 13.5435 0.5 13.5435 0.5H4.12319C2.67391 0.5 2.67391 1.93939 2.67391 1.93939V12.7348C2.67391 14.1742 4.12319 14.1742 4.12319 14.1742M13.5435 14.1742H4.12319M4.12319 14.1742V15.6136C4.12319 16.0095 4.44928 16.3333 4.84783 16.3333C5.24638 16.3333 5.57246 16.0095 5.57246 15.6136V14.1742M5.02899 2.29924C5.02899 2.4 4.94928 2.47917 4.84783 2.47917C4.74638 2.47917 4.66667 2.4 4.66667 2.29924C4.66667 2.19848 4.74638 2.11932 4.84783 2.11932C4.94928 2.11932 5.02899 2.19848 5.02899 2.29924Z"
      :stroke="color"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script setup lang="ts">
import { computed } from "vue";

interface Props {
  size?: number | string;
  color?: string;
  class?: string;
}

const props = withDefaults(defineProps<Props>(), {
  size: 24,
  color: "currentColor",
  class: "",
});

const computedClass = computed(() => props.class);
</script>
